var axios;
var Swiper;
var WebSite;
(function (WebSite) {
    var AFWSwiper = (function () {
        function AFWSwiper(element, swiperSettings) {
            if (swiperSettings === void 0) { swiperSettings = null; }
            this.SwiperSettings = null;
            var swpSetJson = swiperSettings || element.getAttribute('data-swiper-settings');
            if (swpSetJson) {
                this.SwiperSettings = JSON.parse(swpSetJson);
            }
            new Swiper(element, this.SwiperSettings);
        }
        return AFWSwiper;
    }());
    WebSite.AFWSwiper = AFWSwiper;
    var Main = (function () {
        function Main() {
            this.homepageMainSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-homepageMainSwiper-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1,
                    centeredSlides: true,
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 1,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-homepageMainSwiper-button-next',
                        prevEl: '.swiper-homepageMainSwiper-button-prev'
                    },
                });
            };
            this.relatedProductsSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-relatedProductsSwiper-init]');
                elements.forEach(function (el) {
                    var swiper = new Swiper(el, {
                        slidesPerView: 3,
                        observer: true,
                        observeParents: true,
                        spaceBetween: 20,
                        loop: true,
                        navigation: {
                            nextEl: '.swiper-relatedProductsSwiper-button-next',
                            prevEl: '.swiper-relatedProductsSwiper-button-prev'
                        },
                    });
                });
            };
            this.gallerySwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-gallerySwiper-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    centeredSlides: true,
                    loop: true,
                    loopAdditionalSlides: 2,
                    pagination: {
                        el: '.swiper-gallery-pagination',
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            var text = "";
                            for (var i = 1; i <= total; i++) {
                                if (i == 1) {
                                    text += "<span class='numbers'>0" + current + "</span>";
                                }
                                var active = (current == i) ? "active" : "";
                                text += "<span class='custom-pag " + active + "' ></span>";
                                if (i == total) {
                                    text += "<span class='numbers'>0" + total + "</span>";
                                }
                            }
                            return text;
                        }
                    },
                    on: {
                        slideChange: function () {
                            var childNum = $(".swiper-gallery-pagination").children().length - 2;
                            var pagWidth = 550 / childNum;
                            $(".custom-pag").css("width", pagWidth + "px");
                        }
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 1,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-gallerySwiper-button-next',
                        prevEl: '.swiper-gallerySwiper-button-prev'
                    },
                });
            };
            this.mobileContentSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-mobileContentSwiper-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1.07,
                    spaceBetween: 10,
                    loop: true,
                    loopAdditionalSlides: 2,
                    pagination: {
                        el: '.swiper-mobile-content-pagination',
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            var text = "";
                            for (var i = 1; i <= total; i++) {
                                if (i == 1) {
                                    text += "<span class='numbers'>0" + current + "</span>";
                                }
                                var active = (current == i) ? "active" : "";
                                text += "<span class='custom-pag " + active + "' ></span>";
                                if (i == total) {
                                    text += "<span class='numbers'>0" + total + "</span>";
                                }
                            }
                            return text;
                        }
                    },
                    on: {
                        slideChange: function () {
                            var childNum = $(".swiper-mobile-content-pagination").children().length - 2;
                            var pagWidth = 550 / childNum;
                            $(".custom-pag").css("width", pagWidth + "px");
                        }
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 1,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-mobileContentSwiper-button-next',
                        prevEl: '.swiper-mobileContentSwiper-button-prev'
                    },
                });
            };
            this.mobileNewsContentSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-mobileNewsContentSwiper-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1.07,
                    spaceBetween: 10,
                    loop: true,
                    loopAdditionalSlides: 2,
                    pagination: {
                        el: '.swiper-mobile-news-content-pagination',
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            var text = "";
                            for (var i = 1; i <= total; i++) {
                                if (i == 1) {
                                    text += "<span class='numbers'>0" + current + "</span>";
                                }
                                var active = (current == i) ? "active" : "";
                                text += "<span class='custom-pag " + active + "' ></span>";
                                if (i == total) {
                                    text += "<span class='numbers'>0" + total + "</span>";
                                }
                            }
                            return text;
                        }
                    },
                    on: {
                        slideChange: function () {
                            var childNum = $(".swiper-mobile-news-content-pagination").children().length - 2;
                            var pagWidth = 550 / childNum;
                            $(".custom-pag").css("width", pagWidth + "px");
                        }
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 1,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-mobileNewsContentSwiper-button-next',
                        prevEl: '.swiper-mobileNewsContentSwiper-button-prev'
                    },
                });
            };
            this.mobileBlogGallerySwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-mobileBlogGallerySwiper-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1.14,
                    centeredSlides: true,
                    spaceBetween: 10,
                    loop: true,
                    loopAdditionalSlides: 2,
                    pagination: {
                        el: '.swiper-mobile-blog-gallery-pagination',
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            var text = "";
                            for (var i = 1; i <= total; i++) {
                                if (i == 1) {
                                    text += "<span class='numbers'>0" + current + "</span>";
                                }
                                var active = (current == i) ? "active" : "";
                                text += "<span class='custom-pag " + active + "' ></span>";
                                if (i == total) {
                                    text += "<span class='numbers'>0" + total + "</span>";
                                }
                            }
                            return text;
                        }
                    },
                    on: {
                        slideChange: function () {
                            var childNum = $(".swiper-mobile-blog-gallery-pagination").children().length - 2;
                            var pagWidth = 550 / childNum;
                            $(".custom-pag").css("width", pagWidth + "px");
                        }
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 1,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-mobileBlogGallerySwiper-button-next',
                        prevEl: '.swiper-mobileBlogGallerySwiper-button-prev'
                    },
                });
            };
            this.mobileWhyUsContentSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-mobileWhyUsContentSwiper-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    loop: true,
                    loopAdditionalSlides: 2,
                    pagination: {
                        el: '.swiper-mobile-why-us-content-pagination',
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            var text = "";
                            for (var i = 1; i <= total; i++) {
                                if (i == 1) {
                                    text += "<span class='numbers'>0" + current + "</span>";
                                }
                                var active = (current == i) ? "active" : "";
                                text += "<span class='custom-pag " + active + "' ></span>";
                                if (i == total) {
                                    text += "<span class='numbers'>0" + total + "</span>";
                                }
                            }
                            return text;
                        }
                    },
                    on: {
                        slideChange: function () {
                            var childNum = $(".swiper-mobile-why-us-content-pagination").children().length - 2;
                            var pagWidth = 550 / childNum;
                            $(".custom-pag").css("width", pagWidth + "px");
                        }
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 1,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-mobileWhyUsContentSwiper-button-next',
                        prevEl: '.swiper-mobileWhyUsContentSwiper-button-prev'
                    },
                });
            };
            this.mobileCalendarContentSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-mobileCalendarContentSwiper-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    centeredSlides: true,
                    pagination: {
                        el: '.swiper-mobile-calendar-content-pagination',
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            var text = "";
                            for (var i = 1; i <= total; i++) {
                                if (i == 1) {
                                    text += "<span class='numbers'>0" + current + "</span>";
                                }
                                var active = (current == i) ? "active" : "";
                                text += "<span class='custom-pagi " + active + "' ></span>";
                                if (i == total) {
                                    text += "<span class='numbers'>0" + total + "</span>";
                                }
                            }
                            return text;
                        }
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 1,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-mobileCalendarContentSwiper-button-next',
                        prevEl: '.swiper-mobileCalendarContentSwiper-button-prev'
                    },
                });
            };
            this.mobileRelatedProductsContentSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-mobileRelatedProductsContentSwiper-init]');
                elements.forEach(function (el) {
                    var swiper = new Swiper(el, {
                        observer: true,
                        observeParents: true,
                        slidesPerView: 2,
                        spaceBetween: 10,
                        loop: true,
                        loopAdditionalSlides: 2,
                        initialSlide: 0,
                        pagination: {
                            el: '.swiper-mobile-related-products-content-pagination',
                            type: 'custom',
                            renderCustom: function (swiper, current, total) {
                                console.log(swiper, current, total);
                                var text = "";
                                for (var i = 1; i <= total; i++) {
                                    if (i == 1) {
                                        text += "<span class='numbers'>0" + current + "</span>";
                                        text += "<div class='pag-bullets'>";
                                    }
                                    var active = (current == i) ? "active" : "";
                                    text += "<span class='custom-pag " + active + "' ></span>";
                                    if (i == total) {
                                        text += "</div>";
                                        text += "<span class='numbers'>0" + total + "</span>";
                                    }
                                }
                                console.log(text);
                                return text;
                            }
                        },
                        breakpoints: {
                            992: {
                                slidesPerView: 1,
                            },
                            768: {
                                slidesPerView: 1,
                            }
                        },
                        navigation: {
                            nextEl: '.swiper-mobileRelatedProductsContentSwiper-button-next',
                            prevEl: '.swiper-mobileRelatedProductsContentSwiper-button-prev'
                        },
                    });
                });
            };
            this.hangWebsiteSubmitForms = function () {
                var elements = document.querySelectorAll('[data-wssubmitform]');
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    hangAsyncSubmitToForm(el);
                }
            };
            this.bindSwiperTmpFunc = function () {
                var elements = document.querySelectorAll('[data-swiper-init]');
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    new WebSite.AFWSwiper(el);
                }
            };
            this.referencesSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-references-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    centeredSlides: true,
                    loop: true,
                    slideToClickedSlide: true,
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 2,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-references-button-next',
                        prevEl: '.swiper-references-button-prev'
                    },
                });
                swiper.on("slideChange", function () {
                    $(".comments-block").removeClass("active");
                    $(".comments").find('[data-index="' + swiper.realIndex + '"]').addClass("active");
                });
            };
            this.stickyNavigation = function () {
                var header = $("header");
                if ($(window).scrollTop() >= 1) {
                    header.addClass("sticky");
                }
                else {
                    header.removeClass("sticky");
                }
                $(window).scroll(function () {
                    if ($(window).scrollTop() >= 1) {
                        header.addClass("sticky");
                    }
                    else {
                        header.removeClass("sticky");
                    }
                });
            };
            this.mobileMenu = function () {
                var hamburger = $("#hamburger-menu");
                var mobileMenu = $("#mobile-menu");
                var header = $("header");
                var body = $("body");
                var buttonsMobileMenu = $(".mobile-menu-footer .btn");
                hamburger.on("click", function () {
                    mobileMenu.toggleClass("open");
                    hamburger.toggleClass("open");
                    body.toggleClass("overflow");
                    if (!header.hasClass("sticky")) {
                        header.addClass("sticky");
                    }
                });
                buttonsMobileMenu.on("click", function () {
                    mobileMenu.toggleClass("open");
                    hamburger.toggleClass("open");
                    body.toggleClass("overflow");
                });
            };
            this.homepageMainSwiper();
            this.relatedProductsSwiper();
            this.gallerySwiper();
            this.mobileContentSwiper();
            this.mobileWhyUsContentSwiper();
            this.mobileCalendarContentSwiper();
            this.mobileNewsContentSwiper();
            this.mobileBlogGallerySwiper();
            this.mobileRelatedProductsContentSwiper();
            this.hangWebsiteSubmitForms();
            this.bindSwiperTmpFunc();
            this.referencesSwiper();
            this.stickyNavigation();
            this.mobileMenu();
        }
        return Main;
    }());
    WebSite.Main = Main;
    var searchBar = document.getElementById('FrutekSearch');
    var searchBarMobile = document.getElementById('FrutekSearchMobile');
    var inputHandler = function (e) {
        if (e.target.value != "") {
            $("#search-results").css("display", "flex");
            $(".search-results").css("display", "flex");
        }
        else {
            $("#search-results").css("display", "none");
            $(".search-results").css("display", "none");
        }
        var oldVal = e.target.value;
        setTimeout(function () {
            var value = e.target.value;
            if (oldVal == value)
                ShowFinds(value);
        }, 300);
    };
    function ShowFinds(searchVal) {
        $.ajax({
            type: "POST",
            url: "/umbraco/Surface/PageSearchSurface/PageSearch",
            data: { 'searchTerm': searchVal, 'currentCulture': Dictionary.Culture },
            success: function (response) {
                var searchResults = response.items;
                $("a.find-all").empty().attr("href", Dictionary.SearchPage + "?searchTerm=" + searchVal).append(Dictionary.ShowAll + " (" + response.count + ")");
                var products, articles, blogposts;
                products = searchResults.filter(function (searchResult) { return searchResult.contentType == "product"; });
                articles = searchResults.filter(function (searchResult) { return searchResult.contentType == "articulateNewsPost"; });
                blogposts = searchResults.filter(function (searchResult) { return searchResult.contentType == "articulateTendersPost"; });
                $('.result-list-wrapper').html((products.length == 0 && blogposts.length == 0 && articles.length == 0) ?
                    (Dictionary.NoResultsFor + " '<b>" + searchVal + "</b>'.") : "\n                    " + (products.length ? renderProducts(products) : '') + "\n                    " + (blogposts.length ? renderBlogposts(blogposts) : '') + "\n                    " + (articles.length ? renderArticles(articles) : '') + "\n                    ");
                $(".find-all").css("display", (response.count > 0) ? "block" : "none");
            },
        });
    }
    var renderProducts = function (products) {
        var html = "<div class=\"products-wrapper\"><p class=\"result-title\">" + Dictionary.Products + "</p>";
        products.forEach(function (product) {
            html += "<a href=\"" + product.linkUrl + "\"><div class='product-row'><div class='product-image'>\n                <div class='product-background-color " + product.color.toLowerCase() + "'></div><img src=" + product.imageUrl + "'/></div>\n                <div class='product-info'><p class='product-subcategory'>" + (product.subTitle != null ? product.subTitle : '') + "</p>\n                <p class='product-name'>" + product.title + "</p></div></div></a>";
        });
        html += "</div>";
        return html;
    };
    var renderBlogposts = function (blogposts) {
        var html = "<div class=\"blogs-wrapper\"><p class=\"result-title\">" + Dictionary.Blogs + "</p>";
        blogposts.forEach(function (blogpost) {
            html += "<a href=\"" + blogpost.linkUrl + "\"><div class='blog-row'><p class='date'>" + blogpost.createDate + "</p><p class='blog-title'>" + blogpost.title + "</p></div></a>";
        });
        html += "</div>";
        return html;
    };
    var renderArticles = function (articles) {
        var html = "<div class=\"news-wrapper\"><p class=\"result-title\">" + Dictionary.News + "</p>";
        articles.forEach(function (article) {
            html += "<a href=\"" + article.linkUrl + "\"><div class='blog-row'><p class='date'>" + article.createDate + "</p><p class='blog-title'>" + article.title + "</p></div></a>";
        });
        html += "</div>";
        return html;
    };
    searchBar.addEventListener('input', inputHandler);
    searchBarMobile.addEventListener('input', inputHandler);
    function hangAsyncSubmitToForm(form) {
        form.addEventListener('submit', function (e) {
            var formEl = $(this);
            if (!formEl.valid())
                return;
            e.preventDefault();
            grecaptcha.ready(function () {
                grecaptcha.execute('6LesNHAiAAAAACZmfyoVQgx2JGa0J6xfVBbdiCtp', { action: 'submit' }).then(function (token) {
                    var allData = AllForWeb.getFormData(form);
                    console.log(token);
                    $.ajax({
                        type: "POST",
                        dataType: "JSON",
                        method: "POST",
                        processData: false,
                        contentType: false,
                        data: allData
                    }).then(function (result) {
                        console.log(this.data);
                        var formResponse = formEl.find(".form-respons");
                        formResponse.show();
                        var formStructure = formEl.find(".form-submit");
                        formStructure.hide();
                        setTimeout(function () {
                            formEl.find('input').not('[type=hidden], [type=checkbox]').val('');
                            var formResponse = formEl.find(".form-respons");
                            formResponse.hide();
                            var formStructure = formEl.find(".form-submit");
                            formStructure.show();
                        }, 3000);
                    }, function (err) {
                        console.log("Error: ", err);
                    });
                });
            });
        });
    }
    WebSite.hangAsyncSubmitToForm = hangAsyncSubmitToForm;
})(WebSite || (WebSite = {}));
(function () {
    new WebSite.Main();
    reveal();
    var domainName = window.location.hostname;
    var cookieMain = $('.cookie');
    var cookieWarning = $(".cookie-dialog", cookieMain);
    $("#accept-cookies", cookieMain).on('click', function () {
        Cookies.set("analytic_consent", "1", { expires: 365, path: '/', domain: domainName });
        Cookies.set("analytic_consentNoPopUp", "1", { expires: 30, path: "/", domain: domainName });
        $('.cookie-dialog', cookieMain).fadeOut();
        window.location.reload();
    });
    var lastScrollTop = 0;
    $(window).on('scroll', function () {
        var el = $('.landing-shape');
        var currentBottomOffset = parseInt(el.css('bottom'));
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            el.css('bottom', currentBottomOffset + 5 + "px");
        }
        else {
            el.css('bottom', currentBottomOffset - 5 + "px");
        }
        lastScrollTop = st;
    });
    function reveal() {
        var reveals = document.querySelectorAll(".image-lazy");
        for (var i = 0; i < reveals.length; i++) {
            var windowHeight = window.innerHeight;
            var elementTop = reveals[i].getBoundingClientRect().top;
            var elementVisible = 150;
            if (elementTop < windowHeight - elementVisible) {
                reveals[i].classList.add("active");
                console.log("a");
            }
        }
    }
    window.addEventListener("scroll", reveal);
    $('.mobile-dropdown-toggle').on('click', function () {
        $('.mobile-dropdown').toggleClass('show');
    });
    var mobileNewsContentChildNum = $(".swiper-mobile-news-content-pagination").children().length - 2;
    var mobileNewsContentPagWidth = (($(".mobile .slider-wrapper").width()) / 326 * 132.5) / mobileNewsContentChildNum;
    $(".custom-pag").css("width", mobileNewsContentPagWidth + "px");
    var mobileBlogGalleryContentChildNum = $(".swiper-mobile-blog-gallery-pagination").children().length - 2;
    var mobileBlogGalleryContentPagWidth = ($(".slider-wrapper.mobile .swiper-wrapper").width() / 375 * 132.5) / mobileBlogGalleryContentChildNum;
    $(".custom-pag").css("width", mobileBlogGalleryContentPagWidth + "px");
    var mobileWhyUsContentChildNum = $(".swiper-mobile-why-us-content-pagination").children().length - 2;
    var mobileWhyUsContentPagWidth = ($(".mobile .slider-wrapper").width() / 326 * 132.5) / mobileWhyUsContentChildNum;
    $(".swiper-mobile-why-us-content-pagination .custom-pag").css("width", mobileWhyUsContentPagWidth + "px");
    var childNum = $(".swiper-gallery-pagination").children().length - 2;
    var pagWidth = 550 / childNum;
    $(".desktop .custom-pag").css("width", pagWidth + "px");
})();
var initLandingSwiper = (function () {
    var el = document.querySelector("#landing-swiper");
    var swiper = new Swiper(el, {
        effect: 'fade',
        speed: 1000,
        autoplay: {
            delay: 3000,
        },
        slidesPerView: 1,
        navigation: {
            nextEl: '.landing-swiper-next',
            prevEl: '.landing-swiper-prev',
        },
        pagination: {
            el: '.landing-swiper-pagination',
            renderBullet: function (index, className) {
                return '<span class="' + className + '" data-id="' + index + '"></span>';
            },
            clickable: true,
        }
    });
})();
function showImages() {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $('.image-lazy-2').offset().top;
    var elemBottom = elemTop + $('.image-lazy32').height();
}
function showMoreNews(index, ammount) {
    var hideButton = ".button-" + index;
    var showMore = ".show-breakpoint-" + (index + ammount);
    $(hideButton).css("display", "none");
    $(showMore).css("display", "flex");
}
function openAges() {
    $(".mobile-age-box").toggleClass("active");
    $(".mobile-category-box.active").removeClass("active");
    $(".mobile-size-box.active").removeClass("active");
}
function openCategories() {
    $(".mobile-age-box.active").removeClass("active");
    $(".mobile-category-box").toggleClass("active");
    $(".mobile-size-box.active").removeClass("active");
}
function openSize() {
    $(".mobile-age-box.active").removeClass("active");
    $(".mobile-category-box.active").removeClass("active");
    $(".mobile-size-box").toggleClass("active");
}
function closeBottomWindow() {
    $(".mobile-age-box").removeClass("active");
    $(".mobile-category-box").removeClass("active");
    $(".mobile-size-box").removeClass("active");
}
function toggleOpenClose() {
    $("div.menu-line-up").toggleClass("tilted-left");
    $("div.menu-line-down").toggleClass("tilted-right");
    $(".mobile-menu-visible").toggleClass("active");
}
function showSubLinks() {
    $("div.dropdown-link").toggleClass("is-open");
    $("div.dropdown-links").toggleClass("show-links");
}
function hideMobileSearch() {
    $(".mobile-search").toggleClass("mobile-search-open");
}
$('.expand').on('click', function () {
    $(this).toggleClass("active");
    $('.mobile-menu').toggleClass("visible");
});
//# sourceMappingURL=Main.js.map